import React, { useState } from 'react';
import { Button, Header, Modal } from 'semantic-ui-react';
import AmsModal from '../../../utils/AmsModal';
import AmsAlert from '../../../utils/AmsAlert';

const ShowEnableCitationDialog = props => {
  const [showCitationEnabledAlert, setShowCitationEnabledAlert] = useState(
    false
  );

  return (
    <>
      <AmsModal
        size="small"
        centered={false}
        closeOnDimmerClick={false}
        onClose={() => {
          props.close();
        }}
        open={props.showCitationEnableAlert}
        className="ams-semantic-modal-fix"
      >
        <Modal.Content>
          <Header content="Are you sure you want to enable this citation?" />
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={() => {
              props.close();
            }}
            primary
            content="Cancel"
          />
          <Button
            onClick={() => {
              setShowCitationEnabledAlert(true);
              props.save();
            }}
            color="green"
            content="Enable Citation"
          />
        </Modal.Actions>
      </AmsModal>

      <AmsAlert
        show={showCitationEnabledAlert}
        title="This citation has been enabled"
        type="info"
        showConfirm
        confirmButtonText="OK"
        confirmButtonColor="#FF0000"
        onConfirm={() => {
          setShowCitationEnabledAlert(false);
        }}
      />
    </>
  );
};

export default ShowEnableCitationDialog;
